module.exports = __webpack_public_path__ + "img/杨建华.3e06067a.jpg";